import React, { ReactElement } from "react";
import { RouterProps, Router } from "@swiggy-private/core-ui";
import { CartRoutes } from "@swiggy-private/cart-client";
import { RouteContainer, CheckoutRoute } from "@swiggy-private/checkout-core";
import { PaymentRoutes, OUT_IN_ROUTES } from "@swiggy-private/payment-client";

export type CheckoutRouterProps = Omit<RouterProps<CheckoutRoute>, "children">;

export const CheckoutRouter = (props: CheckoutRouterProps): ReactElement => {
    const routes = [...PaymentRoutes];
    routes.push(...CartRoutes);
    return (
        <Router {...props} container={RouteContainer} nonOverlappingTransitionRoutes={OUT_IN_ROUTES}>
            {routes}
        </Router>
    );
};
